import { DPageLoadingWrapper } from "./DPageLoadingWrapper";
import { DResponsiveWindow } from "./DResponsiveWindow";
// All page must be includes this
export function DBasePage({
  children,
  style,
  fullwidth,
}: {
  children: any;
  style?: any;
  fullwidth?: boolean;
}) {
  return (
    <DPageLoadingWrapper style={{ marginTop: 20 }} stickyNotification>
      {fullwidth ? (
        <div style={style}>{children}</div>
      ) : (
        <DResponsiveWindow style={style}>{children}</DResponsiveWindow>
      )}
    </DPageLoadingWrapper>
  );
}
